<template>
	<div>
		<v-list-item-title class="primary--text">
			<span>{{ data.clinica }}</span>
			<v-icon dense color="primary" style="position: absolute; right: 12px; top: 12px;" 
			@click.stop="$emit('open-clinic-dialog', data)">
			mdi-pencil
		</v-icon>
		</v-list-item-title>
		<v-list-item-subtitle v-if="data.id < 7" style="font-weight: 500; padding: 5px 0;">{{ getAddress() }}</v-list-item-subtitle>
		<v-list-item-subtitle v-if="data.id < 7" style="font-weight: 500; padding-bottom: 5px;">{{ getLocation() }}</v-list-item-subtitle>
		<v-list-item-subtitle v-if="data.id < 7" style="padding-bottom: 5px;">
			<v-icon small color="primary">mdi-email</v-icon>
			{{ data.emailclinica && data.emailclinica.length > 0 ? data.emailclinica : '--' }}
		</v-list-item-subtitle>
		<v-list-item-subtitle v-if="data.id < 7" style="padding-bottom: 5px;">
			<v-icon small color="primary">mdi-phone</v-icon>
			{{ data.telclinica && data.telclinica.length > 0 ? data.telclinica : '--' }}
		</v-list-item-subtitle>
		<v-list-item-subtitle :style="{ paddingTop: data.id < 7 || getType() == -1 ? '0' : '25px' }">
			<div v-if="data.id < 7">
				<v-icon small color="primary">mdi-account</v-icon>
				{{ data.respoclinica && data.respoclinica.length > 0 ? data.respoclinica : '--' }}
			</div>
			<v-chip
				x-small
				v-if="getType() > -1"
				style="position: absolute; right: 12px; bottom: 12px;"
				:style="{ backgroundColor: getType() == 0 ? '#E4E4E4' : '#ff5252', color: getType() == 0 ? '#065535' : 'white' }">
				{{ getType() == 0 ? 'Modificado' : 'Borrado' }}
			</v-chip>
		</v-list-item-subtitle>
	</div>
</template>

<script>
import BaseModule from "./BaseModule";

export default {
	name: 'ClinicItem',
	mixins: [ BaseModule ],
	props: [ 'data' ],
	data() {
		return {
			getAddress: function() {
				var text = '';

				if (this.data.tipoviacli && this.data.tipoviacli.length > 0) {
					text += this.data.tipoviacli;
				}

				if (this.data.dirclinica && this.data.dirclinica.length > 0) {
					text += text.length > 0 ? ' ' : '';
					text += this.data.dirclinica;
				}

				if (this.data.numeroclinica && this.data.numeroclinica.length > 0) {
					text += text.length > 0 ? ', ' : '';
					text += this.data.numeroclinica;
				}

				if (this.data.pisoclinica && this.data.pisoclinica.length > 0) {
					text += text.length > 0 ? ' - ' : '';
					text += this.data.pisoclinica;
				}

				return text.length > 0 ? text : '???';
			},
			getLocation: function() {
				var text = '';

				if (this.data.cpclinica && this.data.cpclinica.length > 0) {
					text += this.data.cpclinica;
				}

				if (this.data.pobclinica && this.data.pobclinica.length > 0) {
					text += text.length > 0 ? ' ' : '';
					text += this.data.pobclinica;
				}

				if (this.data.provclinica && this.data.provclinica.length > 0) {
					text += text.length > 0 ? ' - ' : '';
					text += this.data.provclinica;
				}

				return text.length > 0 ? text : '???';
			},
			// returns: -1 -> Not found ; 0 -> edited ; 1 -> deleted
			getType() {
				var item = this.$store.state.icoev.editedClinics.find(x => x.clinic.id == this.data.id);
				if (!item) return -1;
				return item.deleted ? 1 : 0;
			}
		}
	}
}
</script>